export const firstLetterToUpperCase = (str?: string | null) => {
  if (!str) return str;
  return str?.charAt(0)?.toUpperCase() + str?.slice(1);
};
